import { ADMIN_UPDATE_USER, UPDATE_USER_PROFILE } from 'constants/apiConstant';
import { callApi } from 'services/util';

import { runInDevelopment } from 'util/utils';

export class UserService {
  static async updateUserProfile(request = {}) {
    return callApi({ ...ADMIN_UPDATE_USER, request });
  }
}

void runInDevelopment?.(() => void (window.__UserService = UserService));
